import { FC } from 'react'
import { FetchState, InfoAlert, ListLoading, useModal } from 'app/components'
import { EsusConfiguracaoView } from '../../core/_esusModels'
import { EsusStatusCard } from './EsusStatusCard'
import { EsusConfigForm } from './EsusConfigForm'

type Props = {
  empresaId: number
  unidadeId?: number
  onSaved?: () => void
}

export const EsusConfigModal: FC<Props> = ({ empresaId, unidadeId, onSaved }) => {
  const { fetchStates, closeModal, setData } = useModal()
  const isUnidadeMode = !!unidadeId

  const { data: config, isLoading } = (fetchStates['config'] ||
    {}) as FetchState<EsusConfiguracaoView>

  const handleConfigChanged = (updated: EsusConfiguracaoView) => {
    setData('config', updated)
    onSaved?.()
  }

  const handleFormSaved = (updated: EsusConfiguracaoView) => {
    handleConfigChanged(updated)
    closeModal()
  }

  if (isLoading) {
    return <ListLoading />
  }

  return (
    <div>
      {isUnidadeMode ? (
        config?.herdadoDaEmpresa && (
          <InfoAlert variant='info' title='Configuração padrão do município'>
            Campos em branco nesta unidade herdam os valores da configuração padrão da
            empresa/município — o valor herdado aparece como sugestão no campo. Preencha um campo
            apenas quando esta unidade precisar de um valor próprio.
          </InfoAlert>
        )
      ) : (
        <InfoAlert variant='info' title='Configuração padrão do município'>
          Estes valores valem para todas as unidades da empresa. Cada unidade herda os campos que
          não preencher na própria configuração.
        </InfoAlert>
      )}

      {isUnidadeMode && (
        <EsusStatusCard
          empresaId={empresaId}
          unidadeId={unidadeId}
          config={config}
          onConfigChanged={handleConfigChanged}
        />
      )}

      <EsusConfigForm
        empresaId={empresaId}
        unidadeId={unidadeId}
        config={config}
        onSaveSuccess={handleFormSaved}
        onCancel={closeModal}
      />
    </div>
  )
}
